<template>
  <div class="animated fadeIn list-trfout-inv">
    <b-card>
      <div slot="header">Inventory Transfer Out - INTER COMPANY
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Delete</b-button>
          <button class="btn btn-primary mr-1" @click="print()">
              <i class="fa fa-print"></i> Print
          </button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="togleFilter()">
            <i class="fa fa-filter"></i> Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
          <b-form-group label-cols=3 label="Warehouse">
              <b-row>
                <b-col class="pr-1" cols="5">
                  <b-form-select v-model="tblData.idStore" :plain="true" :options="Warehouse" ></b-form-select>
                </b-col>
                <b-col class="pr-1" cols="2"><label style="text-align: center; width:30px !important;">To</label></b-col>
                <b-col class="pl-1" cols="5">
                  <b-form-select v-model="tblData.idStoreTo" :plain="true" :options="Warehouse"></b-form-select>
                </b-col>
              </b-row>                      
          </b-form-group>
          <b-form-group label-cols=3 label="Transfer Doc. No.">
              <b-row>
                <b-col class="pr-1" cols="6"><b-form-input v-model="tblData.nomor" placeholder="Doc. Number"></b-form-input></b-col>
                <b-col class="pl-1" cols="6"><b-form-input v-model="tblData.createby" placeholder="Issued By"></b-form-input></b-col>
              </b-row>                      
          </b-form-group>
          <b-form-group label-cols=3 label="Transfer Item">
              <b-form-input v-model="tblData.transferItem" placeholder="Name/Description"></b-form-input>
          </b-form-group>
          <b-form-group label-cols=3 label="Transfer Date">
              <b-row>
                <b-col class="pr-1" cols="4"><b-form-input v-model="tblData.tgl1" type="date" placeholder="from date"></b-form-input></b-col>
                <b-col class="pl-1" cols="4"><b-form-input v-model="tblData.tgl2" type="date" placeholder="until date"></b-form-input></b-col>
                <b-col class="pl-1" cols="4">
                  <b-input-group >
                      <b-input-group-prepend><label style="text-align: left; width:50px !important;">Status</label></b-input-group-prepend>
                      <b-form-select v-model="tblData.postingStatus" :plain="true" :options="dataList.openStatus"></b-form-select>
                  </b-input-group >
                </b-col>
              </b-row>                      
          </b-form-group>
        </b-col>
        <b-col lg="6">
          <b-form-group label-cols=3 label="Dimension Name">
              <b-row>
                <b-col class="pr-1" cols="5"><b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select></b-col>
                <b-col class="pl-1" cols="5"><b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input></b-col>
              </b-row>                      
          </b-form-group>
          <b-form-group label-cols=3 label="Item Group/Category">
              <b-row>
                <b-col class="pr-1" cols="5"><b-form-input v-model="tblData.nmcategory" placeholder="Category"></b-form-input></b-col>
                <!-- <b-col class="pl-1" cols="7">
                  <b-form-radio-group  v-model="tblData.jasa" name="radioJasa" class="ml-1 mt-1">
                      <b-form-radio :value="0">Material Purchase</b-form-radio>
                      <b-form-radio :value="1">Service Purchase</b-form-radio>
                  </b-form-radio-group>                  
                </b-col> -->
              </b-row>                      
          </b-form-group>
          <b-form-group label-cols=3 >
              <b-row>
                <b-button class="btn btn-success ml-3 mr-1" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                <b-button class="btn btn-secondary mr-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
              </b-row>
          </b-form-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked" 
        show-empty
      >
        <template v-slot:cell(action)="data">
          <b-dropdown dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret size="sm"
            style="margin:-10px;">
            <template v-slot:button-content>
              <i class="fa fa-play text-primary"></i>
            </template>
            <b-dropdown-item @click="rowEdit(data.item)" href="#" style="padding:0 !important;">Edit</b-dropdown-item>
            <b-dropdown-item @click="rowPrint(data.item)" href="#" style="padding:0 !important;">Print
              BPB</b-dropdown-item>
            <b-dropdown-item @click="rowPrintJv(data.item)" href="#" style="padding:0 !important;">Print
              JV</b-dropdown-item>
            <b-dropdown-item @click="rowDel(data.item)" href="#" style="padding:0 !important;"> Delete</b-dropdown-item>
          </b-dropdown>
        </template>
        
        <template v-slot:cell(nomor)="data">
           <span v-if="(data.item.invTrfReceivby != null && data.item.invTrfReceivDate != null )" style="color:green;">{{data.item.nomor}}</span>
          <span v-else>{{data.item.nomor}}</span>
        </template>
        <template v-slot:cell(tanggal)="data">
          {{ data.item.tanggal | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(fromNameStore)="data">
          {{ data.item.compcode}} &nbsp;| &nbsp;
          {{ data.item.fromNameStore}}
        </template>
        <template v-slot:cell(toCompcode)="data">
          {{ data.item.toCompcode}} &nbsp;| &nbsp;
          {{ data.item.toNameStore}}
        </template>
        
        <template v-slot:cell(itemname)="data">
          <div v-if="data.item.posting == 0" style="background-color:yellow;">
                {{data.item.partnumber}} | {{data.item.itemname}}
          </div>
          <div v-else>
                {{data.item.partnumber}} | {{data.item.itemname}}
          </div>
        </template>
        <template v-slot:cell(quantity)="data">
          {{data.item.qtyTrfOut}} &nbsp; {{data.item.invunitom}}
        </template>
        <template v-slot:cell(nilai)="data">
        <span v-if="(data.item.issueValue)">{{data.item.matauang}} &nbsp;{{data.item.issueValue|numFormat}}</span>
        </template>
        <template v-slot:cell(receivby)="data">
          <span v-if="(data.item.invTrfReceivby != null && data.item.invTrfReceivDate != null )">Yes</span>
          <span v-else>No</span>
        </template>
        <template v-slot:cell(empty)="scope">
          <h4>{{ scope.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="scope">
          <h4>{{ scope.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page"  style="margin-top:0 !important;">
            <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
      <b-modal v-model="showPostingConfirm" title="Posting Record?" :centered="true" @ok="postingData">
        <p class="mb-1">The selected a row of data will be Posted to Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">You can unpost as long as <strong>Accounting Periode</strong> stil open</p>
      </b-modal>
      <b-modal v-model="showUnpostConfirm" title="Un Posting Record?" :centered="true" @ok="unpostData">
        <p class="mb-1">The selected a row of data will be UnPosted from Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">Data Journal will be removed from <strong>Accounting</strong></p>
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<style lang="scss">
  .list-trfout-inv {
    table {
      td {
        .dropdown-item {
          padding: 0.1rem 1.5rem !important;
          font-size: smaller !important;
        }
      }
    }

  }
</style>>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import invtrf from "../../apis/logistic_inv_trf";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
toastr.init();

export default {
  components: { Loading},
  data() {
    return {
      showFilter: false,
      showDelConfirm: false,
      showPostingConfirm: false,
      showUnpostConfirm: false,
      horizontal: true,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      Warehouse : [],
      model:{},
        items: [],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        tgl1:this.$store.state.user.tglaktif,
        tgl2:this.$store.state.user.akhirbln,
        sortBy: 'tanggal',
        sortDesc: true,
        idStore:'',
        idStoreTo:'',
        nomor:'',
        createby:'',
        transferItem:'',
        DimCol:'Dim1',
        postingStatus:'',
        
        
      },
      dataList: {
        openStatus: dropdown.postingStatus
      }      
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    tblFields(){
      const fields=[
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
          {
            key: "nomor",
            thStyle: "width:100px",
            label: "Transfer Doc. Number",
            sortable: true
          },
          {
            key: "tanggal",
            thStyle: "width:90px",
            label: "Transfer Date",
            sortable: true
          },
          {
            key: "fromNameStore",
            thStyle: "width:150px",
            label: "Transfer From",
            sortable: true
          },
          {
            key: "toCompcode",
            thStyle: "width:150px",
            label: "transfer To ",
            sortable: true
          },
          {
            key: "uraian",
            label: "Remark/Description",
          },
          {
            key: "itemname",
            label: "Item Inventory",
            sortable: true
          },
          {
            key: "quantity",
            label: "Quantity",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "nilai",
            label: "Inventory Value",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right"
          },
          {
            key: "receivby",
            label: "Receiving Confirmation",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
        ];
      return fields;
    },
    dimCol() {
        return this.tblData.DimCol;
    }    
  },
  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
   data: async function(ctx) {
      let user = this.$store.state.user;
      // this.Warehouse = await invtrf.store(); 
      this.Warehouse = await invtrf.store(user.compcode); 
      this.isLoading=true;
      const tglaktif = moment(new Date(), 'YYYY-MM-DD');
      this.tblData.tgl1 =  tglaktif.startOf('month').format('YYYY-MM-DD');
      this.tblData.tgl2 =  tglaktif.endOf('month').format('YYYY-MM-DD');
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      const list = await invtrf.listoutunit(this.tblData);
      this.items=list;      
      this.isLoading=false;
     return list;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.kodeaccc= '';
        this.tblData.jasa=  '';
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.createby=  '';
        this.tblData.transferItem=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
        this.tblData.postingStatus=  '';
    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    add(){
      router.push({name :"logistic.transferout_invunitform"});
    },
    edit: function() {
        if (this.model.invTrfKey) {
          router.push({name :'logistic.transferout_invunitform', params: { invTrfKey: this.model.invTrfKey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model.invTrfKey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await invtrf.remove(this.model);
      this.refresh();
        // const index= this.items.findIndex(r => (r.invTrfKey==this.model.invTrfKey));
        // this.items.splice(index, 1);
        this.isLoading=false;
      } catch (error) {
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowPost(record) {
      this.rowClicked(record);
      this.posting();
    },
    rowPrint(record) {
      this.rowClicked(record);
      this.print();
    },
    rowPrintJv(record) {
      this.rowClicked(record);
      this.print();
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },

    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    posting: async function () {
        if (this.model.invTrfKey) {
            if ((this.model.posting || 0) == 0) {
                this.showPostingConfirm = true;
            }
            if (this.model.posting == 1) {
                this.showUnpostConfirm = true;
            }
        } else {
            toastr.warn('Please select a row that want to be Posted!');
        }
    }, 
    postingData: async function(){
        this.isLoading=true;
        try {
            await invtrf.posting(this.model);
            this.model.posting=1;
            this.print();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    unpostData: async function(){
        this.isLoading=true;
        try {
            await invtrf.postingUndo(this.model);
            this.model.posting=0;
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    print: async function()
    {
      if (this.model.invTrfKey) {
          this.isLoading=true;
          try {
                this.showReport=true;
              this.reportUrl= await invtrf.print(this.model);
              this.isLoading=false;
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        console.log('this.tblData ',this.tblData)
        try {
            const response = await invtrf.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    close(){
      router.push("/logistic/home");
    },    
  }
};
</script>
